export default __webpack_public_path__ + "locales/ja-JP/SharingPanel.json?hash=fa38797cd7cf8c55f56bb747599b541d";